<div *ngIf="empresas">
    <table class="table distribuidores-table" style="margin: 15px 0;">
        <thead>
            <tr>
                <th colspan="6" class="text-2xl">Distribuidores</th>
            </tr>
            <tr>
                <th>Distribuidor</th>
                <th>RFC</th>
                <th>Correo</th>
                <th>Representante Legal</th>
                <th>Telefono</th>
                <th>Acciones</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let distribuidor of empresas; ">
                <!-- fila encabezado de la factura -->
                <tr class="distribuidores-header">
                    <td><a [routerLink]="['/facturas/empresa', distribuidor.id]">{{ distribuidor.nombre }}</a> </td>
                    <td>{{ distribuidor.rfc }}</td>
                    <td>{{ distribuidor.email}}</td>
                    <td>{{ distribuidor.nombre_contacto}}</td>
                    <td>{{ distribuidor.telefono}}</td>
                    <td></td>

                </tr>
            </ng-container>
            <ng-container *ngIf="empresas.length==0">
                <tr>
                    <td colspan="6" class="text-center p-4">
                        <div class="flex flex-column align-items-center">
                            <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                            <span class="text-600 mt-2">Sin registro de ditrsibuidores</span>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>

</div>